import axios from 'axios';
import clientConfig from '../client-config';
import setAuthToken from '../utils/setAuthToken';
//axios.defaults.withCredentials = true;

export async function getVideos(type, id, free) {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    // Send request
    let apiAddress = '/video/video';
    if (free === true) {
      apiAddress = '/video/fvideo';
    }
    const res = await axios.get(
      clientConfig.backendHOST + apiAddress,
      {
        params: {
          type: type,
          key: id,
        },
      },
      clientConfig.axios_header
    );
    let items = [];

    res.data.map((item) => {
      let rights = [];
      item.KategoriaRights.map((k) => {
        rights.push(k.subscription_code);
      });
      item.MappaRights.map((m) => {
        rights.push(m.subscription_code);
      });
      items.push({
        key: item.videoId,
        videoUrl: item.video_vimeoUrl,
        title: item.videoCim,
        text: item.videoLeiras,
        vimeoCode: item.video_vimeoCode,
        free: item.free,
        accessNeeded: rights,
      });
    });

    if (res.status === 200) {
      return items;
    }
  } catch (err) {
    console.error('error on videos', err);
    return { authFailed: true };
  }
}

export async function getVideoKategoria() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    // Send request

    const res = await axios.get(
      clientConfig.backendHOST + '/video/vk',
      {},
      clientConfig.axios_header
    );
    let items = [];
    res.data.map((item) => {
      items.push({
        kategoriaId: item.kategoriaId,
        kategoriaNev: item.kategoriaNev,
        cldImageName: item.cldImageName,
        kategoriaDescr: item.kategoriaDescr,
      });
    });

    if (res.status === 200) {
      return items;
    }
  } catch (err) {
    return [];
  }
}

export async function getVideoCountByCategory(kategoria, lastLoginDate) {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    // Send request
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const res = await axios.post(
      clientConfig.backendHOST + '/video/videoCount',
      { kategoriaId: kategoria, lastDate: lastLoginDate },
      config
    );

    if (res.status === 200) {
      return res;
    }
  } catch (err) {
    return [];
  }
}

export const writeVideoStatistic = async (statData) => {
  try {
    // Send request
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }
    if (localStorage.token) {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const res = await axios.post(
        clientConfig.backendHOST + '/video/videoStat',
        {
          userId: statData.userId,
          videoId: statData.videoKey,
          playId: statData.playId,
          duration: statData.duration,
          playedSec: statData.playing ? statData.playedSeconds : 0,
        },
        config
      );

      return {
        isOk: true,
        message: 'OK but ignored',
      };
    }
  } catch (err) {
    console.error('error on video stat', err);
    return {
      isOk: true,
      message: 'Error but ignored',
    };
  }
};

export async function getMediaMegjelenes() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    // Send request

    const res = await axios.get(
      clientConfig.backendHOST + '/video/siteFreeVideos',
      {},
      clientConfig.axios_header
    );
    let items = [];

    res.data.map((item) => {
      items.push({
        videoId: item.videoId,
        videoCim: item.videoCim,
        videoLeiras: item.videoLeiras,
        videoUrl: item.video_Url,
      });
    });

    if (res.status === 200) {
      return items;
    }
  } catch (err) {
    return [];
  }
}

export async function getSelectedVideos() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    // Send request
    let apiAddress = '/video/selectedVideos';

    const res = await axios.get(
      clientConfig.backendHOST + apiAddress,
      {},
      clientConfig.axios_header
    );

    const result = res.data;

    if (res.status === 200) {
      return result;
    }
  } catch (err) {
    console.error('error on videos', err);
    return { 'error:': err };
  }
}

export const selectFreeVideo = async (selectedVideo) => {
  try {
    // Send request
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }
    if (localStorage.token) {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const res = await axios.post(
        clientConfig.backendHOST + '/video/selectedVideos',
        {
          selectedVideo,
        },
        config
      );

      return {
        isOk: true,
        message: 'OK but ignored',
      };
    }
  } catch (err) {
    return {
      isOk: true,
      message: 'Error but ignored',
    };
  }
};

export async function FreeTokenAvailable() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    // Send request
    let apiAddress = '/video/freeVideoToken';

    const res = await axios.get(
      clientConfig.backendHOST + apiAddress,
      {},
      clientConfig.axios_header
    );

    const result = res.data;
    if (res.status === 200) {
      return result.weeklyUsed === 0;
    } else {
      return false;
    }
  } catch (err) {
    console.error('error on videos', err);
    return false;
  }
}
